import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { SelectEmpresa } from 'global/components/Selects'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, Trash2Icon, UserRoundPenIcon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { Local, local } from 'service/api'
import { useStore } from 'store'

export default function Locais() {
    const empresaId = useStore(state => state.companyId)
    const { data, isLoading } = local.useFetch({
        queryParams: { empresaId },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Locais']}>
                    <SelectEmpresa hideWhenSingle />
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    onAdd
                    columns={[
                        {
                            field: 'nomeLocal',
                            headerName: 'Nome do Local',
                            flex: 1,
                        },
                        {
                            field: 'endereco',
                            headerName: 'Endereço',
                            minWidth: 50,
                            flex: 1,
                        },
                        {
                            field: 'cercaEletronica',
                            headerName: 'Cerca Eletrônica',
                            width: 140,
                            align: 'center',
                            type: 'number',
                            valueFormatter: ({ value }) => `${value} metros`,
                        },
                        {
                            ...optionsColumn,
                            field: '__associar',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['update', 'Funcionários'],
                                    () => (
                                        <IconButton
                                            title="Associar funcionário"
                                            href={`${id}/associar`}
                                        >
                                            <UserRoundPenIcon />
                                        </IconButton>
                                    ),
                                ),
                        },
                        {
                            ...optionsColumn,
                            field: '__editar',
                            renderCell: ({ id }) =>
                                hasPermission(['update', 'Locais'], () => (
                                    <IconButton
                                        title="Editar"
                                        href={`${id}/editar`}
                                    >
                                        <PencilIcon />
                                    </IconButton>
                                )),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(['delete', 'Locais'], () => (
                                    <IconButton
                                        title="Excluir"
                                        href={`${id}/excluir`}
                                    >
                                        <Trash2Icon className="text-red-500" />
                                    </IconButton>
                                )),
                        },
                    ]}
                    rows={data}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-locais',
                        },
                        showQuickFilter: true,
                    }}
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useLocaisOutletContext() {
    return useOutletContext<{
        data?: Local[]
    }>()
}
